import { format, isToday } from 'date-fns';
import PeriodSection from './PeriodSection';
import DayHeader from './DayHeader';
import EventCard from './EventCard';

export default function DayColumn({
                                      day,
                                      deliveries,
                                      events = [],
                                      onCardClick,
                                      onPrepChange,
                                      users = [],
                                      dayInfo,
                                      teamLocations,
                                      onReload,
                                      livreurColors,
                                      onPause,
                                      holidays = new Set(),
                                      onReportToggle,
                                      onEventClick,
                                      onEventDelete,
                                      onAddEvent,
                                  }) {
    const dateStr = format(day, 'yyyy-MM-dd');
    const today = isToday(day);
    const matin = deliveries.filter(d => d.periode === 'matin');
    const aprem = deliveries.filter(d => d.periode === 'aprem');
    const isFerie = holidays.has(dateStr);

    const eventsMatin = events.filter(e => e.periode === 'matin');
    const eventsAprem = events.filter(e => e.periode === 'aprem');

    return (
        <div style={{
            flex: 1,
            minWidth: '180px',
            backgroundColor: isFerie ? 'var(--hover-bg)' : 'var(--card-bg)',
            borderRadius: '12px',
            padding: '12px',
            boxShadow: today ? '0 0 0 2px var(--accent-color)' : '0 1px 6px rgba(0,0,0,0.07)',
            border: today ? '2px solid var(--accent-color)' : '2px solid transparent',
        }}>
            <DayHeader
                day={day}
                users={users}
                dayInfo={dayInfo}
                teamLocations={teamLocations}
                onReload={onReload}
                onPause={onPause}
            />

            {isFerie && (
                <div style={{
                    textAlign: 'center', fontSize: '10px', fontWeight: '600', color: 'var(--text-muted)',
                    backgroundColor: 'var(--hover-bg)', borderRadius: '4px', padding: '2px 0',
                    marginBottom: '8px', letterSpacing: '0.05em', textTransform: 'uppercase',
                }}>
                    Jour férié
                </div>
            )}

            {/* Events matin */}
            {eventsMatin.map(ev => (
                <EventCard key={ev.id} event={ev} users={users} onClick={onEventClick} onDelete={onEventDelete}/>
            ))}

            <PeriodSection
                id={`${dateStr}-matin`}
                label="Matin"
                deliveries={matin}
                onCardClick={onCardClick}
                onPrepChange={onPrepChange}
                livreurColors={livreurColors}
                onReportToggle={onReportToggle}
            />

            {/* Events après-midi */}
            {eventsAprem.map(ev => (
                <EventCard key={ev.id} event={ev} users={users} onClick={onEventClick} onDelete={onEventDelete}/>
            ))}

            <PeriodSection
                id={`${dateStr}-aprem`}
                label="Après-midi"
                deliveries={aprem}
                onCardClick={onCardClick}
                onPrepChange={onPrepChange}
                livreurColors={livreurColors}
                onReportToggle={onReportToggle}
            />

            <button
                onClick={() => onAddEvent && onAddEvent(dateStr)}
                style={{
                    width: '100%', marginTop: '6px', padding: '3px',
                    backgroundColor: 'transparent', border: '1px dashed #bae6fd',
                    borderRadius: '6px', fontSize: '11px', color: '#7dd3fc', cursor: 'pointer',
                }}
                onMouseEnter={e => {
                    e.currentTarget.style.backgroundColor = '#f0f9ff';
                    e.currentTarget.style.color = '#0ea5e9';
                }}
                onMouseLeave={e => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#7dd3fc';
                }}
            >
                + Événement
            </button>
        </div>
    );
}
